export const hasWindow = () => typeof window !== 'undefined';

export const getWindowOrNull = () => (hasWindow() ? window : null);

export const hasDocument = () => typeof document !== 'undefined';

export const getDocumentOrNull = () => (hasDocument() ? document : null);

export const hasNavigator = () => typeof navigator !== 'undefined';

export const getNavigatorOrNull = () => (hasNavigator() ? navigator : null);
